<template>
  <v-container>
    <p>Supplier</p>
    <v-row>
      <v-col
        cols="12"
        lg="10"
        md="12"
      >
        <v-row>
          <v-col
            cols="4"
            md="2"
          >
            <p>Name:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ supplier.name || '-' }}</p>
          </v-col>
          <v-col
            cols="4"
            md="2"
          >
            <p>Branch:</p>
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            <p>{{ supplier.branch || '-' }}</p>
          </v-col>
        </v-row>
        <app-cleaning-supply-list
          :cleaning_supply_list="cleaning_supply_list"
        />
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'supplier-list' }"
          >
            Back
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "SupplierView",
  components: {
    AppCleaningSupplyList: () => import('../components/cleaning-supply-list.view')
  },
  data: () => ({
    supplier_id: null,
    supplier: {
      name: null,
      branch: null
    },
    cleaning_supply_list: [],
    rules: {
      require: value => !!value || 'Please fill in information',
    },
  }),
  async mounted () {
    let id = this.$route.params.id
    this.getSupplier(id)
  },
  methods: {
    async getSupplier (id) {
      this.supplier_id = id
      try {
        const result = await this.$http.get(`/back-office/suppliers/${this.supplier_id}`, authHeader())
        this.supplier.name = result.data.name
        this.supplier.branch = result.data.branch
        for (let cleaning_supply of result.data.CleaningSupplies) {
          this.cleaning_supply_list.push({
            id: cleaning_supply.id,
            name: cleaning_supply.name,
            price: cleaning_supply.price
          })
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
  },
};
</script>
